module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'site_document_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input id=\'site_document_name\' class=\'text\' name=\'site_document[name]\'>\n        </dd>\n\n        <dt>\n            <label for=\'site_document_description\'>' +
((__t = ( i18next.t('common.description') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <textarea class=\'text\' id=\'site_document_description\' name=\'site_document[description]\'></textarea>\n        </dd>\n\n        <dt>\n            <label for=\'site_document_file\'>' +
((__t = ( i18next.t('ui.upload_file') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' accept=\'.pdf, .jpg, .png, .xls, .xlsx, .zip\' id=\'upload-file\' type=\'file\'/>\n            <span id=\'spinner\' style=\'display:none;color:#224C4F\'>\n                <i class=\'far fa-spinner fa-spin\'></i> ' +
((__t = ( i18next.t('ui.uploading_file') )) == null ? '' : __t) +
'\n            </span>\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}